(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.hotel.controller.core
  (:require
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.hotel.controller.debt-financing
    :refer [debt-financing]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.hotel.controller.details-and-figures
    :refer [details-and-figures]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.hotel.controller.financial-statements
    :refer [financial-statements]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.hotel.controller.overview
    :refer [overview]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.hotel.controller.tearsheet
    :refer
    [tearsheet]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.common.controller :as re]))

(defn ->ui-data
  [{:keys [dynamic-data report-data map-topo] :as props}]
  {:fund-name      (:fund-name report-data)
   :reference-date (get-in report-data [:reference-date])
   :tearsheet      (tearsheet (update props :dynamic-path concat [:tearsheet]))
   :overview       (overview (update props :dynamic-path concat [:overview]))
   :debt-financing (debt-financing (update props :dynamic-path concat [:debt-financing]))
   :esg            (re/esg (update props :dynamic-path concat [:esg]))
   :details-and-figures (details-and-figures
                         (update props :dynamic-path concat [:details-and-figures]))
   :financial-statements (financial-statements
                          (update props :dynamic-path concat [:financial-statements]))})
